import React from 'react';
import Dropdown from "./Dropdown";
import Input from "./Input";
import Range from './Range';
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { INIT_STATE, CACHE_VALUES, RESULT } from '../../types/types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Checkbox from "./Checkbox";
// import { AuthContext } from '../../context/auth-context';
// import getToken from '../../store/auth';
import { load } from 'recaptcha-v3';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import lang from '../../localization/localization';
// import { number } from 'yup/lib/locale';

let responseData = {};
let _formCacheResetterValues = {};
let _formCacheValue = {};
const DynamicForm = (props) => {
    // const { token, setToken } = useContext(AuthContext);
    const [_felid, setFelid] = useState({});
    const [_values, setValues] = useState({});
    const [_reset, setReset] = useState(false);
    const dispatch = useDispatch();
    const formState = useSelector(state => state.mainState);
    const validateSchema = {};
    const formDetailsState = formState.fields;
    const formCacheResetterValues = formState.cacheResetter;
    const formCacheValue = formState.cacheValue;
    const formCacheOptions = formState.cacheOptions;
    const formValidation = formState.validation;
    const autoCalculationFields = formState.automaticCalculation;
    const relatedInputs = formState.relatedInputs;
    const result = formState.result;
    const formInfo = props.info;

    const hideCalculateBtn = () => {
        if (
            document.querySelector('[name="auto_car_condition"]')?.value == ''
            || document.querySelector('[name="cash_programs"]')?.value == ''
            || document.querySelector('[name="mortgage_programs"]')?.value == ''
        ) {
            document.querySelector('.calculators-btn')?.classList.add('invisible')
        } else {
            document.querySelector('.calculators-btn')?.classList.remove('invisible')
        }
    }

    const showNotify = (message) => toast.error(message, {
        position: "top-right",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: 'colored',
    });

    const getCalculators = async () => {
        window.jQuery('.spinner-wrapper').fadeIn();
        // TODO: recaptcha live - comment
        // let token = '';
        // if (window.site_recaptcha_key) {
        //     const recaptcha = await load(window.site_recaptcha_key);
        //     token = await recaptcha.execute();
        // }
        // console.log('calc token:', token);
        axios.get(formInfo.getApi, {
            headers: {
                // TODO: recaptcha live - comment
                // Authorization: token,
            }
        }).then(result => {
            responseData = result.data.data;
            window.jQuery('.spinner-wrapper').fadeOut(1000);
            initInputValues();
        }).catch(error => {
            window.jQuery('.spinner-wrapper').fadeOut(1000);
            console.error(error)
        })
    }

    useEffect(() => {
        // console.log('DynamicForm loaded')
        if (!_reset) {
            getCalculators();
        }
    }, [_reset]);

    useEffect(() => {
        submitData(_values);
    }, [_values])

    useEffect(() => {
        resetValue(_felid);
    }, [_felid]);

    const initInputValues = () => {
        responseData.fields.forEach(field => {
            visibilityConditionHandler(field);
            if (field.type === 'number') {
                formCacheValue[`${field.id}`] = '';
                formCacheResetterValues[`${field.id}_min`] = field.min_value ? field.min_value : '';
                formCacheResetterValues[`${field.id}_max`] = field.max_value ? field.max_value : '';
            } else if (field.type === 'slider') {
                formCacheValue[`${field.id}`] = field.min_value ? field.min_value : 0;
                formCacheResetterValues[`${field.id}_min`] = field.min_value ? field.min_value : 0;
                formCacheResetterValues[`${field.id}_max`] = field.max_value ? field.max_value : '';
            } else if (field.type === 'select') {
                formCacheValue[`${field.id}`] = field.value ? field.value : '';
                formCacheOptions[`${field.id}`] = field.options;
            }
        })
        dispatch(
            {
                type: INIT_STATE,
                payload: {
                    ...formState,
                    fields: responseData.fields,
                    form_button: responseData.form_button,
                    result_title: responseData.result_title,
                    currency: responseData.currency,
                    calc_button: responseData.calc_button,
                    automaticCalculation: responseData.automaticCalculation,
                }
            }
        );
        _formCacheResetterValues = Object.assign({}, formCacheResetterValues);
        _formCacheValue = Object.assign({}, formCacheValue);
    }
    // FIELD WILL SHOW OR HIDE
    const visibilityConditionHandler = (control) => {
        if (!control.visibility_conditions.length) {
            if (Object.keys(formCacheResetterValues).length) {
                formValidation[control.id] = {
                    min: formCacheResetterValues[`${control.id}_min`],
                    max: formCacheResetterValues[`${control.id}_max`],
                    required: control.allow_empty === 0 ? true : false,
                    type: control.type === 'select' ? 'string' : control.type === 'slider' ? 'number' : control.type,
                    id: control.id,
                }
            } else {
                formValidation[control.id] = {
                    min: control.min_value,
                    max: control.max_value,
                    required: control.allow_empty === 0 ? true : false,
                    type: control.type === 'select' ? 'string' : control.type === 'slider' ? 'number' : control.type,
                    id: control.id,
                }
            }
            return true;
        } else {
            let conditionsOfField = control.visibility_conditions[0];
            let booleanExpression = conditionsOfField.operator === "and" ? true : false;
            let operatorFunc = conditionsOfField.operator === "and" ? function (x, y) { return x && y; } : function (x, y) { return x || y; };
            conditionsOfField.field_value_pairs.forEach((field) => {
                let isValidToShow = getField(field) ? true : false;
                booleanExpression = operatorFunc(booleanExpression, isValidToShow);
            })
            if (booleanExpression) {
                if (Object.keys(formCacheResetterValues).length) {
                    formValidation[control.id] = {
                        min: formCacheResetterValues[`${control.id}_min`],
                        max: formCacheResetterValues[`${control.id}_max`],
                        required: control.allow_empty === 0 ? true : false,
                        type: control.type === 'select' ? 'string' : control.type === 'slider' ? 'number' : control.type,
                        id: control.id,
                    }
                } else {
                    formValidation[control.id] = {
                        min: control.min_value,
                        max: control.max_value,
                        required: control.allow_empty === 0 ? true : false,
                        type: control.type === 'select' ? 'string' : control.type === 'slider' ? 'number' : control.type,
                        id: control.id,
                    }
                }
            } else {
                delete formValidation[control.id];
            }
            return booleanExpression;
        }


    }

    const hasAutoCalc = (control) => {
        let inputsHasCalc = false;
        autoCalculationFields.forEach(item => {
            inputsHasCalc = item.args.some(res => {
                if (control.id === res) {
                    relatedInputs[control.id] = {
                        inputs: item.args,
                        method: item.method,
                        result: item.result
                    };
                }
                return control.id === res;
            });
        })
        return inputsHasCalc;
    }

    const calcValueForInput = (control) => {
        let getValue = 0;
        if (relatedInputs[control.id].method === 'minus') {
            let firstInput = formCacheValue[relatedInputs[control.id].inputs[0]].toString().replaceAll(',', '');
            let secondInput = formCacheValue[relatedInputs[control.id].inputs[1]].toString().replaceAll(',', '');
            let validateFirstInput = Number(firstInput) > 0 ? Number(firstInput) : 0;
            let validateSecondInput = Number(secondInput) > 0 ? Number(secondInput) : 0;
            getValue = subtractMethod(validateFirstInput, validateSecondInput);
        }

        formCacheValue[relatedInputs[control.id].result] = getValue.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        dispatch({
            type: CACHE_VALUES,
            payload: formCacheValue,
        })
        formik.setValues(formCacheValue);
    }

    const subtractMethod = (firstInput, secondInput) => {
        return firstInput - secondInput > 0 ? firstInput - secondInput : '';
    }

    const getField = (field) => {
        let selectedItem = formDetailsState.filter(item => item.id === field.field && field.value?.toString() === formCacheValue[item.id]?.toString());
        return selectedItem[0];
    }

    // UPDATE STATE WHEN VALUE CHANGED FOR SELECT
    const valueChangedHandlerSelect = ($event, field) => {
        const { value } = $event.target;
        formCacheValue[field.id] = value;

        if (field.id === formInfo.coreInputs.coreInput1) {
            dispatch(
                {
                    type: INIT_STATE,
                    payload: {
                        ...formState,
                        cacheResetter: { ..._formCacheResetterValues },
                        cacheValue: {
                            ..._formCacheValue,
                            [field.id]: formCacheValue[field.id]
                        },
                        result: {},
                    }
                }
            );
            setFelid({ ...field });
        } else if (field.id === formInfo.coreInputs.coreInput2 || field.id === formInfo.coreInputs.coreInput3) {
            dispatch(
                {
                    type: INIT_STATE,
                    payload: {
                        ...formState,
                        cacheResetter: { ..._formCacheResetterValues },
                        cacheValue: {
                            ..._formCacheValue,
                            [formInfo.coreInputs.coreInput1]: formCacheValue[formInfo.coreInputs.coreInput1],
                            [field.id]: formCacheValue[field.id],
                            result: {},
                        },
                    }
                }
            );
            setFelid({ ...field });
        } else {
            resetValue(field);
        }
    }


    const valueChangedHandlerInput = ($event) => {
        const { value, id, name } = $event.target;
        let targetName = id || name;
        formCacheValue[targetName] = value.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        dispatch(
            {
                type: CACHE_VALUES,
                payload: formCacheValue
            }
        );
        formik.setValues(formCacheValue);
    }

    const valueChangedHandlerCheckBox = ($event) => {
        const { checked, id } = $event.target;
        formCacheValue[id] = checked;
        dispatch(
            {
                type: CACHE_VALUES,
                payload: formCacheValue
            }
        );
    }

    const resetValue = (selectedItem) => {
        formDetailsState.forEach((res) => {
            res.value_resetters.forEach(item => {
                item.field_value_pairs.forEach(field => {
                    if (formCacheValue[selectedItem.id]?.toString() === field.value?.toString()) {
                        if (res.type === 'select') {
                            formCacheOptions[res.id] = [];
                            formCacheOptions[res.id].push(...item.new_values);
                        } else if (res.type === 'slider') {
                            formCacheResetterValues[`${res.id}_min`] = item.min;
                            formCacheResetterValues[`${res.id}_max`] = item.max;
                            formCacheValue[`${res.id}`] = formCacheResetterValues[`${res.id}_min`];
                        } else if (res.type === 'number') {
                            formCacheResetterValues[`${res.id}_min`] = item.min;
                            formCacheResetterValues[`${res.id}_max`] = item.max;
                            formCacheValue[`${res.id}`] = formCacheResetterValues[`${res.id}`] ? formCacheResetterValues[`${res.id}`] : '';
                        }
                    }
                })
            })
            return res;
        })
        dispatch(
            {
                type: INIT_STATE,
                payload: {
                    ...formState,
                    cacheResetter: formCacheResetterValues,
                    cacheOptions: formCacheOptions,
                    validation: { ...formValidation }
                }
            }
        );
        formik.setValues(formCacheValue);
    }
    const validationFun = () => {
        for (let item in formValidation) {
            if (formValidation[item].type === 'string' && formValidation[item].required) {
                validateSchema[item] = Yup.string().required();
            } else if (formValidation[item].type === 'number' && formValidation[item].required) {
                if (formValidation[item].type === 'number' && formValidation[item].min && formValidation[item].max) {
                    validateSchema[item] = Yup.number().transform((o, v) => parseInt(v.toString().replaceAll(/,/g, ''))).positive().min(formValidation[item].min).max(formValidation[item].max).required();
                } else if (formValidation[item].type === 'number' && formValidation[item].min) {
                    validateSchema[item] = Yup.number().transform((o, v) => parseInt(v.toString().replaceAll(/,/g, ''))).positive().min(formValidation[item].min).required();
                } else if (formValidation[item].type === 'number' && formValidation[item].max) {
                    validateSchema[item] = Yup.number().transform((o, v) => parseInt(v.toString().replaceAll(/,/g, ''))).positive().max(formValidation[item].max).required();
                } else {
                    validateSchema[item] = Yup.number().transform((o, v) => parseInt(v.toString().replaceAll(/,/g, ''))).positive().required();
                }
            }
        }
        return Yup.object().shape(validateSchema)
    }

    const resetValues = async (values) => {
        // await getToken().then(res => {
        //     if (res && res.msg == "Loged in successfully.") {
        //         setToken(`Bearer ${res.data.token}`);
        //     }
        setValues({ ...values });
        setReset(true);
        // })
    }

    const replaceNameOfInput = (message, controlId, controlTitle) => {
        return message.replace(controlId, controlTitle);
    }

    const submitData = async (values) => {
        let _values = { ...values };
        for (let item in _values) {
            if (formValidation[item]?.type === 'number' && _values[item].toString().includes(',')) {
                _values[item] = Number(_values[item].replaceAll(',', ''));
            }
            if (!_values[item]) {
                delete _values[item];
            }
        }
        if (Object.keys(_values).length) {
            // TODO: recaptcha live - uncomment
            // let token = '';
            // if (window.site_recaptcha_key) {
            //     const recaptcha = await load(window.site_recaptcha_key);
            //     token = await recaptcha.execute();
            // }
            // console.log('calc token:', token);

            axios.post(formInfo.postApi, _values, {
                headers: {
                    // TODO: recaptcha live - comment
                    // Authorization: token,
                }
            }).then(res => {
                if (res.status == 200) {
                    dispatch({ type: RESULT, payload: { result: { ...res.data.data } } });
                }
                window.jQuery('.spinner-wrapper').fadeOut(1000);
            }).catch(err => {
                err.response.data.data.validation_errors.forEach(err => {
                    showNotify(err);
                    dispatch({ type: RESULT, payload: {} });
                });
                window.jQuery('.spinner-wrapper').fadeOut(1000);
            })
        }
    }

    const formik = useFormik({
        initialValues: formCacheValue,
        enableReinitialize: true,
        validationSchema: validationFun,
        onSubmit: (values) => {
            window.jQuery('.spinner-wrapper').fadeIn();
            toast.dismiss();
            resetValues(values)
        },
    });

    return (
        <>
            <div class="calculators-header">
                <div className="d-inline-block calculators-icon" dangerouslySetInnerHTML={{ __html: formInfo.icon }} />
                <h3 className='calculators-title'>{formInfo.title}</h3>
            </div>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className='col-md-8'>
                        {
                            formDetailsState?.length > 0
                            &&
                            formDetailsState?.map((control, $index) => {
                                return (
                                    <div key={$index.toString()}>
                                        {

                                            control.type === 'select'
                                            &&
                                            visibilityConditionHandler(control)
                                            &&
                                            formCacheOptions[control.id].length > 0
                                            &&
                                            <div className="calculators-control">
                                                <Dropdown
                                                    onChange={($event) => { formik.handleChange($event); valueChangedHandlerSelect($event, control) }}
                                                    id={control.id}
                                                    title={control.title}
                                                    readOnly={control.read_only}
                                                    options={formCacheOptions[control.id]}
                                                    name={control.id}
                                                    placeholder={control.place_holder}
                                                    value={formik.values[control.id] ? formik.values[control.id] : ''}
                                                    isValid={formik.errors[control.id] && formik.touched[control.id]} />
                                                {formik.errors[control.id] && formik.touched[control.id] ? (
                                                    <div className='error'>{replaceNameOfInput(formik.errors[control.id], control.id, control.title)}</div>
                                                ) : null}
                                            </div>
                                        }
                                        {
                                            control.type === 'number'
                                            &&
                                            visibilityConditionHandler(control)
                                            &&
                                            !hasAutoCalc(control)
                                            &&
                                            <div className="calculators-control">
                                                <Input
                                                    onChange={($event) => { formik.handleChange($event); valueChangedHandlerInput($event, control) }}
                                                    type={control.type}
                                                    id={control.id}
                                                    title={control.title}
                                                    readOnly={control.read_only}
                                                    name={control.id}
                                                    placeholder={control.place_holder}
                                                    min={formCacheResetterValues[`${control.id}_min`]}
                                                    max={formCacheResetterValues[`${control.id}_max`]}
                                                    value={formik.values[control.id]}
                                                    isValid={formik.errors[control.id] && formik.touched[control.id]}
                                                />
                                                {formik.errors[control.id] && formik.touched[control.id] ? (
                                                    <div className='error'>{replaceNameOfInput(formik.errors[control.id], control.id, control.title)}</div>
                                                ) : null}
                                            </div>

                                        }
                                        {
                                            control.type === 'number'
                                            &&
                                            visibilityConditionHandler(control)
                                            &&
                                            hasAutoCalc(control)
                                            &&
                                            <div className="calculators-control">
                                                <Input
                                                    onChange={($event) => {
                                                        formik.handleChange($event);
                                                        valueChangedHandlerInput($event, control);
                                                        calcValueForInput(control)
                                                    }}
                                                    type={control.type}
                                                    id={control.id}
                                                    title={control.title}
                                                    readOnly={control.read_only}
                                                    name={control.id}
                                                    placeholder={control.place_holder}
                                                    min={formCacheResetterValues[`${control.id}_min`]}
                                                    max={formCacheResetterValues[`${control.id}_max`]}
                                                    value={formik.values[control.id]}
                                                    isValid={formik.errors[control.id] && formik.touched[control.id]}
                                                />
                                                {formik.errors[control.id] && formik.touched[control.id] ? (
                                                    <div className='error'>{replaceNameOfInput(formik.errors[control.id], control.id, control.title)}</div>
                                                ) : null}
                                            </div>

                                        }
                                        {
                                            control.type === 'slider'
                                            &&
                                            visibilityConditionHandler(control)
                                            &&
                                            <div className="calculators-control">
                                                <Range
                                                    onChange={($event) => { formik.handleChange($event); valueChangedHandlerInput($event, control) }}
                                                    type={control.type}
                                                    id={control.id}
                                                    title={control.title}
                                                    readOnly={control.read_only}
                                                    name={control.id}
                                                    placeholder={control.place_holder}
                                                    min={formCacheResetterValues[`${control.id}_min`]}
                                                    max={formCacheResetterValues[`${control.id}_max`]}
                                                    value={formik.values[control.id]}
                                                />
                                                {formik.errors[control.id] && formik.touched[control.id] ? (
                                                    <div className='error'>{replaceNameOfInput(formik.errors[control.id], control.id, control.title)}</div>
                                                ) : null}
                                            </div>

                                        }

                                        {
                                            control.type === 'note'
                                            &&
                                            visibilityConditionHandler(control)
                                            &&
                                            <div className="calculators-control">
                                                <p>{control.msg}</p>
                                            </div>
                                        }
                                        {
                                            control.type === 'checkbox'
                                            &&
                                            visibilityConditionHandler(control)
                                            &&
                                            <div className="calculators-control">
                                                <Checkbox
                                                    onChange={($event) => { formik.handleChange($event); valueChangedHandlerCheckBox($event, control) }}
                                                    type={control.type}
                                                    id={control.id}
                                                    title={control.title}
                                                    readOnly={control.read_only}
                                                    name={control.id}
                                                    value={formik.values[control.id]}
                                                />
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    {Object.keys(result).length > 0 ? <div className='col-md-4 position-relative'>
                        <div className='calculators-card'>
                            <p className='calculators-card--title'>{lang.calculationResult}</p>
                            <div className='calculators-card__result'>
                                <h5 className="calculators-card__result--title">{lang.monthlyInstallment}</h5>
                                <p className='calculators-card__result--output'>{result?.result?.monthly_installment} {formState.currency}</p>
                            </div>
                        </div>
                    </div> : null}
                </div>
                <div className='row'>
                    <div class="col-md-8">
                        <ToastContainer />
                    </div>
                </div>
                {
                    formState.calc_button ? <button className="btn btn-primary calculators-btn invisible" type="submit">{formState.calc_button}</button> : null
                }
                {/* {
                    formState.form_button ? <button className="btn btn-light calculators-apply" type="button">{formState.form_button}</button> : null
                } */}
                {hideCalculateBtn()}


            </form>
        </>
    )
}


export default DynamicForm;



